__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/45e9df8/_next/";